import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Button } from '@mui/material';
import {
  AdminPanelSettings as PermissionsIcon,
  GroupAdd as UserManagementIcon,
  ArrowBack as BackIcon,
} from '@mui/icons-material';
import { useLanguage } from '../../contexts/LanguageContext';

interface UserTile {
  key: string;
  translationKey: string;
  fallbackLabel: string;
  icon: React.ReactNode;
  path: string | null;
}

const UsersPermissionsPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const tiles: UserTile[] = [
    {
      key: 'permissions',
      translationKey: 'settings.permissions',
      fallbackLabel: 'Permissions',
      icon: <PermissionsIcon sx={{ fontSize: 56, color: '#9ca3af' }} />,
      path: '/settings/program/users/permissions',
    },
    {
      key: 'user_management',
      translationKey: 'settings.user_management',
      fallbackLabel: 'User management',
      icon: <UserManagementIcon sx={{ fontSize: 56, color: '#9ca3af' }} />,
      path: '/settings/program/users/management',
    },
  ];

  return (
    <Box sx={{ p: { xs: 1.5, md: 3 }, pb: { xs: 4, md: 3 }, maxWidth: 1200, mx: 'auto' }}>
      {/* Back Button */}
      <Box sx={{ mb: 3 }}>
        <Button
          startIcon={<BackIcon />}
          onClick={() => navigate('/settings/program')}
          sx={{
            color: '#e0e0e0 !important',
            backgroundColor: '#2a2d42 !important',
            borderRadius: '8px',
            px: 2.5,
            py: 1,
            textTransform: 'none',
            fontSize: '0.9rem',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#33364d !important',
            },
          }}
        >
          {t('settings.back') || 'Back'}
        </Button>
      </Box>

      <Grid container spacing={3}>
        {tiles.map((tile) => (
          <Grid item xs={12} sm={6} md={4} key={tile.key}>
            <Box
              onClick={() => {
                if (tile.path) navigate(tile.path);
              }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                py: 5,
                px: 3,
                borderRadius: '12px',
                backgroundColor: tile.path ? '#2a2d42 !important' : '#252838 !important',
                border: '1px solid #3a3d52',
                cursor: tile.path ? 'pointer' : 'default',
                minHeight: 180,
                transition: 'all 0.15s ease',
                '&:hover': tile.path
                  ? {
                      backgroundColor: '#33364d !important',
                      border: '1px solid #00C896',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
                    }
                  : {},
              }}
            >
              {tile.icon}
              <Typography
                sx={{
                  fontSize: '1rem',
                  fontWeight: 500,
                  color: '#e0e0e0 !important',
                  textAlign: 'center',
                }}
              >
                {t(tile.translationKey) || tile.fallbackLabel}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default UsersPermissionsPage;
